import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { searchMyApplications, searchAllApplications } from "../../actions/api";
import ApplicationSearchModal from "./ApplicationSearchModal";
import { selectHasRole } from "../admin/UtilsAdmin";
import { service_admin_role } from "../../config";

const ApplicationSearch = ({
  title,
  searchMyApplications,
  searchAllApplications,
  onSelect,
  icon,
  disabled = false,
  buttonText = "",
}) => {
  const isServiceAdmin = useSelector(selectHasRole(service_admin_role));

  return (
    <ApplicationSearchModal
      title={title}
      onSelect={onSelect}
      searchForApplication={
        isServiceAdmin ? searchAllApplications : searchMyApplications
      }
      buttonText={buttonText}
      icon={icon}
      disabled={disabled}
    />
  );
};

ApplicationSearch.propTypes = {
  onSelect: PropTypes.func.isRequired,
  searchMyApplications: PropTypes.func.isRequired,
  searchAllApplications: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
};

export default connect(() => ({}), {
  searchMyApplications,
  searchAllApplications,
})(ApplicationSearch);
